"use client";

import Lightbox from 'yet-another-react-lightbox';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import { Slide } from '../../ProductView';

interface GalleryProductProps {
    slides: Slide[];
    index: number;
    setIndex: (index: number) => void;
}

const GalleryProduct = ({ slides, index, setIndex }: GalleryProductProps) => {
    if (!slides || slides.length === 0) return null;

    // تبدیل اسلایدها به فرمتی که Lightbox انتظار دارد (تنها با type: "image")
    const lightboxSlides = slides.map(slide => ({
        src: slide.src,
        alt: slide.alt,
        width: slide.width,
        height: slide.height,
        type: "image" as const
    }));

    return (
        <Lightbox
            slides={lightboxSlides}
            open={index >= 0}
            index={index}
            close={() => setIndex(-1)}
            plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
        />
    );
};

export default GalleryProduct;
